import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: "customize-dialog",
  templateUrl: "./customize-dialog.component.html",
  styleUrls: ["./customize-dialog.component.scss"]
})
export class CustomizeDialogComponent implements OnInit {

    @Output() onBlueButtonClick= new EventEmitter();
    @Output() onWhiteButtonClick= new EventEmitter();
    constructor(
        public dialogRef: MatDialogRef<CustomizeDialogComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any) {}
    ngOnInit(): void {
    }
    onBlueClick(){
        this.dialogRef.close();
        this.onBlueButtonClick.emit();
    }
    onWhiteClick(){
        this.dialogRef.close();
        this.onWhiteButtonClick.emit();
    }
      
}